export default function createRouterMiddleware(history) {
  return (store) => {
    const withQuery = (location) => {
      if (!location) return location;
      if (location.query) return location;

      let search = location.search;
      if (typeof search !== 'string') {
        return { ...location, query: {} };
      }

      if (search.startsWith('?')) search = search.slice(1);

      try {
        // eslint-disable-next-line global-require
        const qs = require('qs');
        const query = qs.parse(search);
        return { ...location, query };
      } catch (e) {
        return { ...location, query: {} };
      }
    };

    if (history) {
      const initialLocation =
        (typeof history.getCurrentLocation === 'function' && history.getCurrentLocation()) ||
        history.location ||
        (typeof window !== 'undefined' && window.location);

      if (initialLocation) {
        store.dispatch({ type: '@@router/UPDATE_LOCATION', payload: withQuery(initialLocation) });
      }
    }

    if (history && typeof history.listen === 'function') {
      history.listen((location) => {
        store.dispatch({ type: '@@router/UPDATE_LOCATION', payload: withQuery(location) });
      });
    }

    return (next) => (action) => {
      if (action && action.type === '@@router/TRANSITION' && action.payload) {
        const { method, args } = action.payload;
        if (history && method && typeof history[method] === 'function') {
          history[method](...(Array.isArray(args) ? args : []));
          return action;
        }
      }

      return next(action);
    };
  };
}
